//TODO - maybe Refactor to make more configurable for cases when the murn fieldname and lookup fieldname could differ. Though we shouldn't be doing that anyways.
//TODO - maybe Refactor or add a function for other cases like long descriptions
//Could get super fancy with generics ....

/** Validates that lookups are populated with description */
export const validateLookupsHaveDescriptions = (entity: any, fieldNames: string[]) => {
  const errorFields: string[] = [];
  fieldNames.forEach((field) => {
    if (entity[`${field}Murn`] && !entity[field]?.description) {
      errorFields.push(field);
    }
  });
  return errorFields;
};

//TODO - Function for lookups with long descriptions or something along that line (if we end up needing it)

/** To be used for fields that are *not* part of the model from the server. We are just checking if they exist, which means they were intentionally set with or without a value. */
export const validateFieldsExist = (entity: any, fieldNames: string[]) => {
  const errorFields: string[] = [];
  fieldNames.forEach((field) => {
    if (!Object.hasOwn(entity, field)) {
      errorFields.push(field);
    }
  });
  return errorFields;
};

//TODO - maybe ValidateFieldsHaveValue function?

const isValidMonth = (potentialMonth: string) => {
  const months = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];
  return months.includes(potentialMonth.toLowerCase());
};

/** Switches the month display from the full month to the 3 letter abbreviation. Returns the original value if it cannot be parsed. */
export const convertDateStringToUseMonthaAbbreviations = (formattedLongDateString: string | null) => {
  if (formattedLongDateString) {
    var splitDate = formattedLongDateString.split(" ");
    if (isValidMonth(splitDate[0])) {
      splitDate[0] = splitDate[0].slice(0, 3);
      splitDate[1] = splitDate[1].replace(/[^0-9,]/g, ""); //Remove the text suffix for dates (ex: th, st)
      return splitDate.join(" ");
    }
  }
  return formattedLongDateString;
};

export const docGenFieldErrorMessage = "Inproperly configured or populated fields: ";
export const comingSoonMessage = "(Coming soon)";
